/**
 * TabulatorEntityPage - Advanced entity management with Tabulator.js
 *
 * Surfaces the TabulatorEntityManager from @ferp/workflow-forms for admin/architect users.
 * Provides high-performance data grid with sorting, filtering, grouping, and export capabilities.
 *
 * Route: /admin/tabulator-entity
 */

import { Container, Title, Group, Badge, Text, ThemeIcon } from '@mantine/core';
import { IconTable } from '@tabler/icons-react';

import { TabulatorEntityManager } from '@ferp/workflow-forms';
import { useAuth } from '@/auth/AuthContext';

export function TabulatorEntityPage() {
  const { tenant } = useAuth();

  return (
    <Container size="xl" py="md">
      <Group justify="space-between" mb="lg">
        <Group gap="sm">
          <ThemeIcon size="lg" variant="light" color="blue">
            <IconTable size={20} />
          </ThemeIcon>
          <div>
            <Title order={3}>Entity Data Manager</Title>
            <Text size="sm" c="dimmed">
              High-performance entity browsing with Tabulator.js grid
            </Text>
          </div>
        </Group>
        {tenant && (
          <Badge variant="light" color="gray">
            {tenant.name}
          </Badge>
        )}
      </Group>

      <TabulatorEntityManager />
    </Container>
  );
}

export default TabulatorEntityPage;
